import { graphql } from '@/client/services/api/graphql/gql';

export const createExpertMutation = graphql(`
  mutation CreateExpert($expert: ExpertCreateInput!) {
    createExpert(expert: $expert) {
      id
      __typename
    }
  }
`);
